<template lang="pug">
div
  app-modal-visualizar-completo(
    v-if="showModalVisualizarProcesso && idProcesso !== null",
    @closeModal="showModalVisualizarProcesso = false",
    :idProcesso="idProcesso",
    :protocolo="protocolo",
    :numeroProcesso="numeroProcesso",
    :tipo="tipoProcesso"
  )
  el-card.card-container(shadow="hover")
    filtro(
      @pesquisar="pesquisar",
      @limpar="clear",
      :showOs="true",
      :showMunicipios="true",
      :configuracaoFiltro="configuracaoFiltro",
      :filtroRapido="filtroRapido"
      :showFiltroTipoMultiplo="showFiltroTipoMultiplo"
    )
  app-listagem(
    :has-refresh-button="true",
    :showButtonOrdemServico="false",
    :showButtonAssinatura="false",
    :has-expansivel="false",
    :json-headers="colunas",
    :json-data="items",
    :totalElements="totalElements",
    :pagina="filtro.pagina",
    :hasFiltroRapido="true",
    :filtro="filtro",
    @atualizarFiltro="atualizarFiltro",
    @updateListagem="refresh",
    @changePage="changePage",
    @sort="sort",
    @executar="executar",
    @selected="false"
  )
</template>

<script>
import AppListagem from '@/components/AppListagem'
import Filtro from './Filtro'
import FILTRO_EMPTY from '@/models/filtro'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
const { filtro, showFiltroTipoMultiplo } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const BaseFiltro = require('./' + process.env.ESTADO + '/BaseFiltro').default

export default {

  beforeRouteLeave (to, from, next) {
    next()
  },

  components: {
    AppListagem,
    Filtro,
    AppModalVisualizarCompleto
  },

  mixins: [
    BaseFiltro
  ],

  data () {
    return {
      filtro: FILTRO_EMPTY('DAE'),
      items: [],
      totalElements: 0,
      showModalVisualizarProcesso: false,
      configuracaoFiltro: {
        filtroSituacao: filtro?.filtroSituacao?.DAE || [],
        filtroDataVencimento: filtro?.filtroDataVencimento?.DAE || []
      },
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', ordem: 1, acoes: [], type: 'icone', icone: 'comment-alt' },
        { id: 1, titulo: 'CPF/CNPJ do Interessado', propriedade: 'cpfCnpjInteressado', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Nome/Razão Social do Interessado', propriedade: 'nomeRazaoSocialInteressado', ordem: 3, acoes: [] },
        { id: 3, titulo: 'Situação', propriedade: 'status', ordem: 4, acoes: [] },
        { id: 4, titulo: 'Município', propriedade: 'municipio', sortable: true, ordem: 3, acoes: [] },
        { id: 5, titulo: 'Data de Vencimento', propriedade: 'dataVencimentoDAE', ordem: 4, acoes: [] },
        { id: 6, titulo: 'Data Chegada', propriedade: 'dataChegadaSetor', ordem: 4, acoes: [] },
        { id: 7, titulo: 'Tipo de Processo', propriedade: 'tipo', ordem: 5, acoes: [] },
        {
          id: 8, titulo: 'Ações', propriedade: 'tipo', ordem: 6, //eslint-disable-line
          acoes: [
            { id: 1, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 1, show: this.showVisualizarProcesso },
            { id: 2, nome: this.labelShowDae(), icone: 'fa-file-invoice-dollar', codigo: 'BOLETO', ordem: 1, show: this.showDae },
            { id: 3, nome: 'Emitir DAE', icone: 'fa-file-invoice-dollar', codigo: 'BOLETO', ordem: 1, show: this.showEmitirDae }
          ]
        }
      ],
      showFiltroTipoMultiplo,
      filtroRapido: null
    }
  },

  props: {
    tipo: {
      type: String,
      required: false // trocar para true, quando tiver a props
    }
  },

  methods: {
    VISUALIZAR_PROCESSO (_this, { item }) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.tipoProcesso = item.tipoCodigo
      this.protocolo = item.numeroProtocolo
      this.showModalVisualizarProcesso = true
    },
    async BOLETO (_this, { item }) {
      this.$router.push({
        name: 'financeiro/dae/CadastroDae',
        params: {
          idProcesso: item.id
        }
      })
    },
    atualizarFiltro (novoFiltro) {
      this.filtroRapido = novoFiltro
    }
  }
}
</script>
<style lang="scss" scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/CaixaDaeListagem.vue